import { cancelOrder } from '@/lib/api/orders';
import { useCartStore } from '@/stores/cart-store';
import { useOrderStore } from '@/stores/order-store';

/**
 * Clears all customer-session state. Used by idle reset and "Transaksi Baru".
 * Any DRAFT order left on the backend is cancelled (fire-and-forget) so
 * abandoned carts don't linger in the orders table; confirmed orders are safe —
 * the instructions screen clears `draftOrderId` and the backend rejects the
 * transition anyway.
 */
export async function resetSession(): Promise<void> {
  const draftId = useOrderStore.getState().draftOrderId;
  if (draftId) void cancelOrder(draftId).catch(() => {});
  useCartStore.getState().clear();
  useOrderStore.getState().reset();
}
